import { TCustomFieldRaw } from '../../users';
import { ECustomFieldType } from '../../users/types/organizations.types';

const extractCustomFieldValue = (fieldRaw: TCustomFieldRaw | null) => {
  if (!fieldRaw) return undefined;
  if (ECustomFieldType.TEXT in fieldRaw) return fieldRaw.TEXT;
  if (ECustomFieldType.DROPDOWN in fieldRaw) return fieldRaw.DROPDOWN;
  if (ECustomFieldType.DATE in fieldRaw) return fieldRaw.DATE;
};

export default extractCustomFieldValue;
